import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2147483647;
`;

export const ProgressText = styled.p`
  margin-top: 1rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
`;
